<template>
  <div>
    <b-container fluid>
      <b-row class="margin-top-30">
        <b-col cols="12">
          <h4>Employers</h4>
          <b-button :to="{ name: 'employerCreate' }">Create</b-button>
          <b-list-group>
            <b-list-group-item :to="{ name: 'employerHome', params: { uuid: employer.uuid } }" v-for="employer in employers">{{employer.title}}</b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'employerAdmin',
  props: [],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
    this.loadEmployers()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadEmployersDetail'
    ]),

    loadEmployers () {
      this.loadEmployersDetail(this.currentInstitutionId).then(res => {
        if (this.employers.length > 0) {
          this.$router.push({name: 'employerHome', params: {uuid: this.employers[0].uuid}})
        }
      })
    }

  },

  computed: {
    ...mapState({
      'employers': state => state.employer.employers
    }),
    currentInstitutionId () {
      var userObj = JSON.parse(localStorage.getItem('userobj'))
      return userObj.institutionId
    }
  },

  watch: {
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/employer/components/EmployerAdmin.vue